module.exports = __webpack_public_path__ + "img/lottery-light.8f6e21fa.png";